/* eslint-disable no-else-return */
import PropTypes from 'prop-types';
import PrequalBlog from './prequalBlog/prequal';
import PrequalPL from './prequalPL/prequalPL';
import PrequalOfferCode from './prequalOffer/prequalOffer';
import PrequalCiabCode from './prequalCiab/prequalCiab';
import HeroHomePrequalCard from '../heroHomePrequal/prequalCard/heroHomePrequalCard';

function Prequal({ prequal, theme }) {
  const type = prequal.prequalType;
  switch (type) {
    case 'Blog':
      return <PrequalBlog {...prequal} />;
    case 'Offer code':
      return <PrequalOfferCode {...prequal} />;
    case 'CIAB Funding Code':
      return <PrequalCiabCode {...prequal} />;
    case 'Home Card':
      return <HeroHomePrequalCard {...prequal} />;
    default:
      return <PrequalPL {...prequal} theme={theme} />;
  }
}

Prequal.propTypes = {
  prequal: PropTypes.object,
  theme: PropTypes.string,
};

export default Prequal;
